/*
  受講生の声の「名前（年齢・肩書き）」の表記。HP・広告 LP・各 LP が同じ字を読む。
  名前と肩書きの正本は、研究所の受講生インタビュー (apps/client/app/lib/lab-interviews.ts、本人の同意で公開した記事)。
  Aさん → あいねさん、Sさん → ユウキさん は、その記事が同じ動画 (voiceSlug) を指していることから決めた。
  研究所には ユウキさん が 2 人いる (04 は IT企業勤務、09 はメーカー企画職)。別人なので年齢と肩書きを必ず添える。
*/
export const VOICE_LABEL = {
  aine: "あいねさん（23歳・私立学校教員）",
  asami: "あさみさん（27歳・接客業）",
  nabe: "なべちゃんさん（30代・技術開発職・2児の母）",
  yuukiIt: "ユウキさん（25歳・IT企業勤務・3年目）",
  yuukiPlan: "ユウキさん（30代前半・メーカー企画職）",
  tabi: "Mさん（27歳・接客業7年目）",
  miyazaki: "宮崎さん（27歳・フリーター）",
} as const;
